
// This is for the non-frames embeddable tables in the main apps page.
function collapseElement(c_id) {
  // on clicking the see more button, unhide counties and the see fewer button
  document.getElementById(
    'collapse-see-more-' + c_id
  ).onclick = function collapse() {
    let collapsible = document.getElementsByClassName('collapsible-' + c_id);

    for (let i = 0; i < collapsible.length; i++) {
      collapsible[i].classList.toggle('display-none');
    }

    document
      .getElementById('see-more-' + c_id)
      .classList.toggle('display-none');
    document
      .getElementById('see-fewer-' + c_id)
      .classList.toggle('display-none');
  };

  // on clicking the see less button, hide counties and the see more button
  document.getElementById(
    'collapse-see-fewer-' + c_id
  ).onclick = function collapse() {
    let collapsible = document.getElementsByClassName('collapsible-' + c_id);

    for (let i = 0; i < collapsible.length; i++) {
      collapsible[i].classList.toggle('display-none');
    }

    document
      .getElementById('see-more-' + c_id)
      .classList.toggle('display-none');
    document
      .getElementById('see-fewer-' + c_id)
      .classList.toggle('display-none');
  };
  // close collapse element
}

var elements = ['counties', 'notes'];

for (var i = 0; i < elements.length; i++) {
  collapseElement(elements[i]);
};
